import * as React from 'react';
import { templateReplace } from '../helpers';

export default function NvChartTooltip(props) {
  const {chartConfig, hoveredDot} = props;

  if (!hoveredDot || !hoveredDot.entry) return null;

  const {title, text} = chartConfig.tooltip;
  const {entry, stroke} = hoveredDot;

  const textParts = text.split('\n');
  const entryText = textParts.map(part => `<div>${templateReplace(part, entry)}</div>`).join('');
  return (
    <div className="nv-chart-tooltip">
      <div className='nv-chart-tooltip__group'>
        <div className='nv-chart-tooltip__label'>{templateReplace(title, entry)}</div>
        <div className='nv-chart-tooltip__content'>
          <div className='nv-chart-tooltip__marker' style={{backgroundColor: stroke}}></div>
          <div className='nv-chart-tooltip__text' dangerouslySetInnerHTML={{__html: entryText}}></div>
        </div>
      </div>
    </div>
  );
}
